/**
 * 관리자 Layout
 * --
 */
import React, { useEffect, useState, useRef } from 'react';
import {
  //Badge,
  Layout,
} from 'antd';
import {
  Content,
  FloatButton,
  Footer,
  // MainFooter,
  MainHeader,
  TopBanner,
} from 'components';
import { useLocation } from 'react-router-dom';
import PClogo from 'assets/jm_shop_logo.svg';

import MessageAlert, {
  getStorage,
  deleteCookie,
  getCookie,
  isMobile,
} from 'utils';
import CONSTANTS from 'constants';

//import Cart from 'assets/icon/cart_icon.svg';
//import Wish from 'assets/icon/wish.svg';
// import Recent from 'assets/icon/recent.svg';
// import Benefit from 'assets/icon/benefit.svg';
//import Top from 'assets/icon/top_icon.png';
import {
  useDefaultShopDataStack,
  useUserAction,
  useUserDataStack,
  useUserStack,
  useUserDataAction,
} from 'store';
import { encrypt } from 'utils/Crypto';
import { useAuthCheck } from 'hooks/AuthHooks';
import SquareFloatButton from 'components/Form/SquareFloatButton';
import { SendOutlined } from '@ant-design/icons';

const MainLayout = (props) => {
  /* ===== Init ===== */
  const googleTranslateRef = React.useRef(null);

  /* ===== Props ===== */
  const {
    children,
    headerExceptPath,
    footerExceptPath,
    siderExceptPath,
    topBannerExceptPath,
    navigate,
    screenSize,
    setLoading,
  } = props;

  /* ===== Route ===== */
  const location = useLocation();
  const { pathname } = location;

  /* ===== Mutate =====*/
  // 토큰 검증
  const { authCheck } = useAuthCheck();

  /* ===== Store ===== */
  const userInfo = useUserStack();
  const userAction = useUserAction();
  const userDataAction = useUserDataAction();

  const { categories, products } = useDefaultShopDataStack();
  const { cartList } = useUserDataStack();

  /* ===== State ===== */
  const contentRef = useRef(null);
  const [isHeader, setIsHeader] = useState(true);
  const [isFooter, setIsFooter] = useState(true);
  const [isSider, setIsSider] = useState(true);
  const [isFixed, setIsFixed] = useState(false);
  // 탑 배너 보임 여부
  const [isTopBanner, setIsTopBanner] = useState(true);
  // 웹뷰 여부
  const [isWebView, setIsWebView] = React.useState(false);

  // 헤더 전체메뉴 카데고리 무한뎁스로 변경
  const mapCategoryRecursive = (category) => ({
    key: category.key,
    title: category.product_category_name,
    onClick: () =>
      navigate(
        `/products?category=${encodeURIComponent(
          encrypt(category.product_category_id),
        )}`,
      ),
    children: Array.isArray(category.children)
      ? category.children.map(mapCategoryRecursive)
      : [],
  });

  const newCategories = categories
    .filter((category) => {
      const isBusiness =
        category.product_category_name === CONSTANTS.BUSINESS_CATEGORY_NAME;

      if (isBusiness) {
        if (userInfo && userInfo?.business_level === 2) return true;
        else return false;
      } else {
        return true;
      }
    })
    .map(mapCategoryRecursive);

  // NOTE: 헤더 드롭다운 카테고리 2뎁스 까지만 표시
  /* const newCategories = categories.slice(0, 8).map((category) => ({
    key: category.key,
    title: category.product_category_name,
    onClick: () =>
      navigate(
        `/products?category=${encodeURIComponent(
          encrypt(category.product_category_id)
        )}`
      ),
    children: category.children.map((child) => ({
      key: child.key,
      title: child.product_category_name,
      onClick: () =>
        navigate(
          `/products?category=${encodeURIComponent(
            encrypt(child.product_category_id)
          )}`
        ),
    })),
  })); */

  /* ===== Function ===== */
  /**
   * 로그아웃
   * --
   * @returns
   */
  const handleLogout = () => {
    const confirm = window.confirm('로그아웃하시겠습니까?');

    if (!confirm) return;

    deleteCookie('JM_COFFEE_ACCESS_TOKEN', {});
    userAction.resetUser();
    userDataAction.resetAllData();

    if (isMobile()) {
      window.ReactNativeWebView.postMessage(
        `${JSON.stringify({ type: 'logout-success' })}`,
      );
    }

    navigate('/main');
    return MessageAlert.success('로그아웃되었습니다.');
  };

  /**
   * 토큰 검증
   * --
   */
  const handleTokenCheck = async (cookie) => {
    // 토큰 검증
    try {
      const { status, data } = await authCheck();

      // NOTE: 검증 실패 처리
      if (status !== 200) {
        userAction.resetUser();
        userDataAction.resetAllData();
        deleteCookie('JM_COFFEE_ACCESS_TOKEN', {});
        return false;
      }

      // NOTE: 검증 성공
      userAction.setUser(data);
      return true;
    } catch (err) {
      console.error('[AUTH] ERROR!! ', err);
      return false;
    }
  };

  /* ===== Hooks ===== */
  /**
   * 헤더 / 푸터 / 플로우팅버튼 예외처리
   * --
   */
  useEffect(() => {
    const call = (path) => {
      const splitPath = path.split('/')[1] ?? '';

      // 헤더 제외 루트 체크
      if (headerExceptPath.includes(splitPath)) {
        setIsHeader(false);
      } else {
        setIsHeader(true);
      }

      // 푸터 제외 루트 체크
      if (footerExceptPath.includes(splitPath)) {
        setIsFooter(false);
      } else {
        setIsFooter(true);
      }

      if (topBannerExceptPath.includes(splitPath)) {
        setIsTopBanner(false);
      } else {
        setIsTopBanner(true);
      }

      // 플로우팅버튼 제외 루트 체크
      if (siderExceptPath.includes(splitPath)) {
        setIsSider(false);
      } else {
        setIsSider(true);
      }
    };
    pathname && call(pathname);
  }, [
    pathname,
    headerExceptPath,
    footerExceptPath,
    siderExceptPath,
    topBannerExceptPath,
    isWebView,
    screenSize,
  ]);

  /**
   * 사이드 메뉴 Fixed
   * --
   */
  useEffect(() => {
    const call = () => {
      const scrollY = window.scrollY;
      const offsetTop =
        contentRef.current.getBoundingClientRect().top + window.pageYOffset;

      if (scrollY + 87 > offsetTop) {
        if (!isFixed) {
          setIsFixed(true);
        }
      } else {
        if (isFixed) {
          setIsFixed(false);
        }
      }
    };

    if (contentRef) {
      window.addEventListener('scroll', call);
    }

    return () => {
      window.removeEventListener('scroll', call);
    };
    // eslint-disable-next-line
  }, []);

  /**
   * 탑배너 숨김 여부 체크
   * --
   */
  useEffect(() => {
    const isExist = getStorage('top_banner_hide');

    if (isExist) setIsTopBanner(false);
    else setIsTopBanner(true);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.google && window.google.translate) {
        clearInterval(interval);
        new window.google.translate.TranslateElement(
          {
            pageLanguage: 'ko',
            includedLanguages: 'en,ko', // 원하는 언어 (영어, 한국어 등)
            layout:
              window.google.translate.TranslateElement.InlineLayout.VERTICAL,
          },
          googleTranslateRef.current,
        );
      }
    }, 100);
    return () => clearInterval(interval);
  }, []);

  /**
   * 장바구니 상품수
   * --
   */
  const CartNum = React.useMemo(() => {
    if (!cartList?.length || !products?.length) return 0;

    const mapProducts = new Map(
      products.map((product) => [product.product_id, product]),
    );

    return cartList.reduce((acc, cur) => {
      const product = mapProducts.get(cur.product_id);

      if (!product) return acc;

      return (acc += cur.cart_num);
    }, 0);
  }, [cartList, products]);

  React.useEffect(() => {
    const isNative = window.ReactNativeWebView;
    // const mobileCheck = navigator.userAgent.includes('JmWebViewAgent');

    setIsWebView(isNative);

    if (isNative) {
      const cookie = getCookie('JM_COFFEE_ACCESS_TOKEN');

      if (cookie) {
        handleTokenCheck(cookie);
      }
    } else {
      handleTokenCheck();
    }
  }, []);

  /* ===== Style ===== */
  const styles = {
    layout: {
      position: 'relative',
      top: 0,
      left: 0,
    },
    header: {
      position: 'sticky',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 3000,
      background: 'none',
      padding: 0,
    },
    container: {
      width: '100%',
      position: 'relative',
      top: 0,
      left: 0,
      backgroundColor: '#FFFFFF',
      // overflow: 'hidden',
    },
    floatButton: {
      position: isFixed ? 'fixed' : 'absolute',
      width: 100,
      // NOTE: 고정할 높이: 헤더 높이 + 헤더로부터 고정할 거리
      top: isFixed ? 150 : 800,
      right: 30,
      background: 'red',
      zIndex: 100,
      transition: 'none',
    },
  };

  /* ===== Render ===== */
  return (
    <Layout style={styles.layout}>
      <div
        ref={googleTranslateRef}
        style={{
          position: 'fixed',
          right: 15,
          bottom: 15,
          zIndex: 999,
          background: '#fff',
          opacity: 0.85,
          color: '#fff',
          padding: '5px 8px',
          borderRadius: 5,
          boxShadow: '1px 1px 12px -3px rgba(0,0,0,0.25)',
        }}
      ></div>

      {/* ===== 탑배너 ===== */}
      {userInfo ? null : (
        <TopBanner
          maxWidth={1820}
          height={48}
          isShow={isTopBanner}
          onClick={() => navigate('/signup')}
        >
          <p style={{ fontSize: 14 }}>지금 가입하고, 웰컴쿠폰 받아가세요!</p>
        </TopBanner>
      )}
      {/* ===== /탑배너 ===== */}

      {/* 해더 */}
      {isHeader ? (
        <div style={styles.header}>
          <MainHeader
            maxWidth={1820}
            logo={
              <img
                src={PClogo}
                alt="로고"
                style={{
                  height: 'auto',
                  width: screenSize <= 768 ? '100%' : '50%',
                }}
              />
            }
            categories={newCategories}
            screenSize={screenSize}
            isLogin={userInfo ? true : false}
            name={userInfo?.user_name}
            onLogout={handleLogout}
            cartNum={CartNum}
            setLoading={setLoading}
            isWebView={isWebView}
          />
        </div>
      ) : null}
      {/* 해더 끝 */}

      {/* 본문 */}
      <Layout ref={contentRef} style={{ ...styles.container }}>
        {/* 본문 */}
        <Content
          maxWidth={'100%'}
          backgroundColor={'none'}
          padding={0}
          style={{
            position: 'relative',
            top: 0,
            left: 0,
            zIndex: 100,
          }}
        >
          {children}
        </Content>
        {/* 본문 끝 */}
      </Layout>

      {/* 푸터 */}
      {isFooter ? (
        <Footer />
      ) : // <MainFooter background={'#EEEEEE'} style={{ paddingBottom: 64 }} />
      null}
      {/* 푸터 끝 */}

      {/* 사각 플로우트 버튼 */}
      {isSider ? (
        <Layout style={styles.floatButton}>
          <SquareFloatButton />
        </Layout>
      ) : null}
      {/* 사각 플로우트 버튼 끝 */}

      {isSider && screenSize <= 768 ? (
        <FloatButton.Group style={{ bottom: 100, right: 5 }}>
          <FloatButton
            style={{ backgroundColor: '#111111' }}
            onClick={() => navigate('/cs/inquire')}
          >
            <SendOutlined style={{ color: '#FFFFFF', fontSize: 18 }} />
          </FloatButton>
        </FloatButton.Group>
      ) : null}
      {/* 원형 플로우트 버튼 */}
      {/* {isSider && (
        <FloatButton.Group>
          <FloatButton style={{ backgroundColor: '#FFFFFF' }}>
            <img src={Recent} alt="최근 본 상품" />
          </FloatButton>
          <FloatButton style={{ backgroundColor: '#FFFFFF' }}>
            <img src={Wish} alt="찜" />
          </FloatButton>
          <FloatButton style={{ backgroundColor: '#FFFFFF' }}>
            <img src={Benefit} alt="멤버십 혜택" />
          </FloatButton>
          <FloatButton
            style={{ backgroundColor: '#FFFFFF' }}
            onClick={() => navigate('/order/cart?type=delivery')}
          >
            <Badge count={CartNum}>
              <img src={Cart} alt="장바구니" />
            </Badge>
          </FloatButton>
          <FloatButton
            style={{ backgroundColor: '#FFFFFF' }}
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <img src={Top} alt="상단으로 이동" />
          </FloatButton>
        </FloatButton.Group>
      )} */}
      {/* 원형 플로우트 버튼 끝 */}
    </Layout>
  );
};

export default MainLayout;
